import React, { createContext, useContext, useEffect, useState } from 'react';
import useCountryActions from '../hooks/APIHooks/users/useCountryActions';
import { Country, CountryReqBody } from '../types/countries';

// datatype of the context declared here
interface ICountryContext {
  targetedCountry: Country | null;
  countryList: Array<Country>;
  selectedCountries: Array<CountryReqBody>;
  searchText: string;
  showDeleteModal: boolean;
  showEditModal: boolean;
  setTargetedCountry: React.Dispatch<React.SetStateAction<Country | null>>;
  setSelectedCountries: React.Dispatch<
    React.SetStateAction<Array<CountryReqBody>>
  >;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
}

// creating the context here
const CountryContext = createContext<ICountryContext | null>(null);

const CountryProvider = ({ children }: { children: React.ReactNode }) => {
  // integration of react hooks here
  const [targetedCountry, setTargetedCountry] = useState<Country | null>(null);
  const [countryList, setCountryList] = useState<Array<Country>>([]);

  const [selectedCountries, setSelectedCountries] = useState<
    Array<CountryReqBody>
  >([]);

  const [searchText, setSearchText] = useState<string>('');

  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  // integration of custom API hooks here
  const { getCountryListHandler } = useCountryActions('countryList');

  console.log('COUNTRY LIST: ', getCountryListHandler.data?.data);

  useEffect(() => {
    if (getCountryListHandler.data?.is_success) {
      setCountryList(
        getCountryListHandler.data.data.filter((country) =>
          country.country_name.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    }
  }, [getCountryListHandler.data, searchText]);

  // rendering the context provider here
  return (
    <CountryContext.Provider
      value={{
        targetedCountry,
        countryList,
        selectedCountries,
        searchText,
        showDeleteModal,
        showEditModal,
        setTargetedCountry,
        setSelectedCountries,
        setSearchText,
        setShowDeleteModal,
        setShowEditModal,
        isError: getCountryListHandler.isError,
        isLoading: getCountryListHandler.isLoading,
        isSuccess: getCountryListHandler.isSuccess,
      }}
    >
      {children}
    </CountryContext.Provider>
  );
};

export default CountryProvider;

// custom hook to access the context declared here
export const useCountryContext = () => {
  const context = useContext(CountryContext);

  if (!context) {
    throw new Error('useCountryContext must be within CountryProvider!');
  }

  return context;
};
